import request from "@/config/utils/request";

//查询数据字典
export function qryDictByCode(data) {
  return request({
    url: "/apis/scpma/common/qryDictByCode",
    method: "post",
    data
  });
}

//	查询供应商注册审核列表
export function querySupplierRegisterApprovalList(data) {
  return request({
    url: "/apis/bid/smc/querySupplierRegisterApprovalList",
    method: "post",
    data
  });
}

// 审批记录查询接口
export function qryApprovalRecord(data) {
  return request({
    url: "/apis/bid/mtc/qryApprovalRecord",
    method: "post",
    data
  });
}

//供应商注册或变更查询供应商基本信息。
export function qrySupRegistBaseInfo(data) {
  return request({
    url: "/apis/bid/smc/qrySupRegistBaseInfo",
    method: "post",
    data
  });
}
//查询供应商基本信息。
export function qrySupBaseInfo(data) {
  return request({
    url: "/apis/bid/smc/qrySupBaseInfo",
    method: "post",
    data
  });
}

//供应商注册中查询供应商历史合作业绩信息
export function qrySupRegistHisPerform(data) {
  return request({
    url: "/apis/bid/smc/qrySupRegistHisPerform",
    method: "post",
    data
  });
}

//供应商查询签订合同业绩
export function qrySignContract(data) {
  return request({
    url: "/apis/bid/smc/qrySignContract",
    method: "post",
    data
  });
}

//查询供应商历史合作业绩信息
export function qrySupHisPerform(data) {
  return request({
    url: "/apis/bid/smc/qrySupHisPerform",
    method: "post",
    data
  });
}

//供应商注册中查询资质文件信息
export function qrySupRegistQualificationFileList(data) {
  return request({
    url: "/apis/bid/smc/qrySupRegistQualificationFileList",
    method: "post",
    data
  });
}
//供应商查询资质文件信息
export function qrySupplierQualificationFile(data) {
  return request({
    url: "/apis/bid/smc/qrySupplierQualificationFile",
    method: "post",
    data
  });
}

//供应商注册中查询联系信息
export function qrySupRegistContactInfo(data) {
  return request({
    url: "/apis/bid/smc/qrySupRegistContactInfo",
    method: "post",
    data
  });
}
//供应商联系信息
export function qrySupplierLinkInfo(data) {
  return request({
    url: "/apis/bid/smc/qrySupplierLinkInfo",
    method: "post",
    data
  });
}
//供应商注册、变更产品信息
export function qrySupRegistProductInfo(data) {
  return request({
    url: "/apis/bid/smc/qrySupRegistProductInfo",
    method: "post",
    data
  });
}
//供应商产品信息
export function qrySupplierProductInfo(data) {
  return request({
    url: "/apis/bid/smc/qrySupplierProductInfo",
    method: "post",
    data
  });
}
//供应商注册、变更财务信息
export function qrySupRegistFinanceInfo(data) {
  return request({
    url: "/apis/bid/smc/qrySupRegistFinanceInfo",
    method: "post",
    data
  });
}
//供应商财务信息
export function qrySupFinanceInfo(data) {
  return request({
    url: "/apis/bid/smc/qrySupFinanceInfo",
    method: "post",
    data
  });
}
//供应商考核任务信息
export function qryAssessScoreInfoList(data) {
  return request({
    url: "/apis/bid/smc/qryAssessScoreInfoList",
    method: "post",
    data
  });
}
//供应商中标金额
export function qrySupBidAmountList(data) {
  return request({
    url: "/apis/bid/smc/qrySupBidAmountList",
    method: "post",
    data
  });
}
//查询供应商类型
export function qrySuptypeQualList(data) {
  return request({
    url: "/apis/bid/smc/qrySuptypeQualList",
    method: "post",
    data
  });
}
//查询所在区域
export function qryAddressRegion(data) {
  return request({
    url: "/apis/bid/common/qryAddressRegion",
    method: "post",
    data
  });
}
//省市区地址列表查询
export function qryAddressByCodeRegion(data) {
  return request({
    url: "/apis/scpma/common/qryAddressByCodeRegion",
    method: "post",
    data
  });
}
// 物资类别数据
export function qryMatcateryTreeList(data) {
  return request({
    url: "/apis/scpma/mtc/qryMatcateryTreeList",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}
// 查询供应商所属单位
export function qryUnitOrgTree(data) {
  return request({
    url: "/apis/scpma/org/qryUnitOrgTree",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}
// 查询变更说明
export function qrySupApplyRemark(data) {
  return request({
    url: "/apis/scpma/smc/qrySupApplyRemark",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}
// 供应商管理数据列表查询
export function qrySupManageDataList(data) {
  return request({
    url: "/apis/scpma/smc/qrySupManageDataList",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}
// 供应商管理设置操作
export function setSupManage(data) {
  return request({
    url: "/apis/scpma/smc/setSupManage",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 供应商推荐列表查询
export function qrySupRecommendList(data) {
  return request({
    url: "/apis/scpma/smc/qrySupRecommendList",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}
// 供应商推荐审核列表查询
export function qrySupRecommendApprovalList(data) {
  return request({
    url: "/apis/scpma/smc/qrySupRecommendApprovalList",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 供应商信息列表查询
export function qrySupInfoList(data) {
  return request({
    url: "/apis/scpma/smc/qrySupInfoList",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}
// 供应商退回管理列表查询
export function qrySupReturnList(data) {
  return request({
    url: "/apis/scpma/smc/qrySupReturnList",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}
// 供应商变更审批列表查询
export function querySupplierChangeApprovalList(data) {
  return request({
    url: "/apis/scpma/smc/querySupplierChangeApprovalList",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}
// 供应商密码重置列表查询
export function qrySupResetPwdList(data) {
  return request({
    url: "/apis/scpma/smc/qrySupResetPwdList",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 查询供应商冻结或禁用状态列表
export function querySupplierFrozenOrDisableStatusList(data) {
  return request({
    url: "/apis/bid/smc/querySupplierFrozenOrDisableStatusList",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 审批接口
export function approvalOperate(data) {
  return request({
    url: "apis/scpma/mtc/approvalOperate", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 退回人员选择查询
export function getReturnPerson(data) {
  return request({
    url: "/apis/scpma/mtc/querySelectablePerson",
    method: "post",
    data
  });
}
// 供应商合作意向申请审核列表查询
export function qrySupCoopUnitApprovalList(data) {
  return request({
    url: "/apis/scpma/smc/qrySupCoopUnitApprovalList",
    method: "post",
    data
  });
}
// 查询推荐人所在单位
export function listUserPartJobComInfo(data) {
  return request({
    url: "/apis/scpma/org/listUserPartJobComInfo",
    method: "post",
    data
  });
}
// 供应商推荐操作
export function dealSupRecommend(data) {
  return request({
    url: "/apis/scpma/smc/dealSupRecommend",
    method: "post",
    data
  });
}

// 查询供应商维护列表
export function qrySupMaintainList(data) {
  return request({
    url: "/apis/scpma/smc/qrySupMaintainList",
    method: "post",
    data
  });
}
// 修改保存提交供应商注册信息
export function saveSupplierRegistInfo(data) {
  return request({
    url: "/apis/scpma/smc/saveSupplierRegistInfo",
    method: "post",
    data
  });
}
// 查询密码重置列表/供应商注册状态列表
export function qrySupRegistStatusList(data) {
  return request({
    url: "/apis/scpma/smc/qrySupRegistStatusList",
    method: "post",
    data
  });
}
// 供应商退回
export function dealSupApprReturn(data) {
  return request({
    url: "/apis/scpma/smc/dealSupApprReturn",
    method: "post",
    data
  });
}
// 供应商层级调整
export function dealSupAdjustLevel(data) {
  return request({
    url: "/apis/scpma/smc/dealSupAdjustLevel",
    method: "post",
    data
  });
}
// 查询所属供应商列表
export function qryBelongSupplierList(data) {
  return request({
    url: "/apis/scpma/smc/qryBelongSupplierList",
    method: "post",
    data
  });
}
// 修改保存提交供应商信息变更
export function saveSupplierChangeInfo(data) {
  return request({
    url: "/apis/scpma/smc/saveSupplierChangeInfo",
    method: "post",
    data
  });
}
// 供应商推荐单位录入后校验是否存在
export function checkRecommendOrg(data) {
  return request({
    url: "/apis/scpma/smc/checkRecommendOrg",
    method: "post",
    data
  });
}
// 供应商推荐单位录入后校验是否存在
export function createSupplierChangeInfo(data) {
  return request({
    url: "/apis/scpma/smc/createSupplierChangeInfo",
    method: "post",
    data
  });
}
// 密码重置
export function dealSupplierResetPwd(data) {
  return request({
    url: "/apis/scpma/smc/dealSupplierResetPwd",
    method: "post",
    data
  });
}
// 查询推荐单位
export function qryRecommendOrgTree(data) {
  return request({
    url: "/apis/scpma/smc/qryRecommendOrgTree",
    method: "post",
    data
  });
}
// 查询供应商合作单位列表
export function qrySupCoopUnitList(data) {
  return request({
    url: "/apis/scpma/smc/qrySupCoopUnitList",
    method: "post",
    data
  });
}
// 查询供应商国别
export function qryAllDiffCounAddress(data) {
  return request({
    url: "/apis/scpma/common/qryAllDiffCounAddress",
    method: "post",
    data
  });
}
// 查询校验供应商名称、统一信用代码、用户名等是否已存在
export function checkSuppilerInfo(data) {
  return request({
    url: "/apis/scpma/smc/checkSuppilerInfo",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 天眼查查询供应商
export function qryTycSearch(data) {
  return request({
    url: "/apis/scpma/smc/qryTycSearch",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 查询供应商在天眼查中的信息
export function qrySupTycInfo(data) {
  return request({
    url: "/apis/scpma/smc/qrySupTycInfo",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 查询申请人所属单位及兼职单位列表区分供应或采
export function qryUserPartCompanyList(data) {
  return request({
    url: "/apis/scpma/org/qryUserPartCompanyList",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}
